export default [
  {
    path: "/conversation-summary",
    name: "conversation-summary",
    component: () => import("@/views/question/View.vue"),
    meta: {
      pageTitle: "breadcrumb.summaryConversation",
      navActiveLink: "conversation-summary",
      resource: "summary-conversation",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.summaryConversation",
          active: true,
        },
      ],
    },
  },
];
